import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { GenericRESTPagedClientManager } from "../../../../js/lib/manager/GenericRESTPagedClientManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const CurrentLoansClientManager = function() {
  let instance = null;
  return {
    getInstance: (options) => {
      if(instance){
        return instance;
      }
      instance = new CurrentLoansClientManagerClass(options);
      return instance;
    }
  }
}();

class CurrentLoansClientManagerClass extends GenericRESTPagedClientManager {
  constructor(options) {
    super(
      $.extend(
        {
          //searchEvent:    LS2PAC_CONSTANTS.Events.onSearch,
          resultsPanelId: options.resultsPanelId,
          restUrl: LS2PAC_CONSTANTS.restUrls.getCurrentLoans,
          pageSize: 20,
        },
        options
      )
    );

    this.restOptions.cancellable = true;
    this.restOptions.cache = false;
    this.sortField = this.defaultSort = "Status";
    this.addListeners();
  }
  fireSearch(event) {
    this.search(
      this.currentPage * this.pageSize,
      this.pageSize,
      this.sortField
    );
  }
  resetPageCache() {
    this.pages = [];
    this.hasResults = false;
    this.currentPage = 0;
  }
  setTotalHits(totalHits) {
    this.resetPageCache();
    this.totalHits = totalHits;
  }
  renewLoans(event) {
    var hackListOfIdsForHTML = event.hackListOfIdsForHTML;
    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.renewLoans, {
      postData: {
        renewLoanInfos: event.loans,
      },
      callback: function (data) {
        $.each(data.renewLoanInfos, function (index, loanRenewReturn) {
          if (hackListOfIdsForHTML[index]) {
            loanRenewReturn = $.extend(
              loanRenewReturn,
              hackListOfIdsForHTML[index]
            );
          }
        });
        TLCLogger.log("renewLoans response", data.renewLoanInfos);
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onRenewLoansResponse,
          { success: true, data: data.renewLoanInfos }
        );
      },
      error: function (error) {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onRenewLoansResponse,
          { success: false }
        );
      },
      cache: false,
    });
  }
  addListeners() {
    var _this = this;

    TLCEventManager.addListener(this.searchEvent, function (event) {
      _this.resetPageCache();
      _this.fireSearch(event);
      _this.addHistory(event);
    });

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRenewLoans,
      function (event) {
        _this.renewLoans(event);
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.sortField = _this.defaultSort;
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetAllCurrentLoans,
      function (event) {
        var success = false,
          response = {};
        TLCRest.jsonCall(
          [
            LS2PAC_CONSTANTS.restUrls.getCurrentLoans,
            0,
            event.total,
            _this.sortField,
            "false",
          ].join("/"),
          {
            callback: function (data) {
              success = true;
              response = data.loans;
              TLCLogger.log("getCurrentLoans response", data);
            },
            finallyHandler: function () {
              TLCEventManager.fireEvent(
                LS2PAC_CONSTANTS.Events.onGetAllCurrentLoansResponse,
                { success: success, data: response }
              );
            },
            timeout: 60000,
            cancellable: true,
            cache: false,
          }
        );
      }
    );
  }
}
